// extracted by mini-css-extract-plugin
export default {"signUpModal":"Signup_signUpModal__3GDvF","modalClose":"Signup_modalClose__uAIOV"};